import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { ExtranetRoomForm } from 'app/typings/packages';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS as HOTEL_QUERY_KEYS } from '../hotel/index';

import { ENDPOINTS } from '.';

export function useRoomBeds(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { rooms: ExtranetRoomForm[] }) =>
      apiMutation(
        'PUT',
        {
          path: ENDPOINTS.saveRoomBeds,
          params: { id: hotelId.toString() },
        },
        payload
      ) as Promise<{ roomIds: number[] }>,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [HOTEL_QUERY_KEYS.hotelRooms],
      });
    },
    onError: (err) => {
      message.error('Error while saving room beds');
    },
  });
}
